export default "__VITE_ASSET__BiyXeKdU__"